export const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
export function matchesReference(value, query) {
  const target = normalize(value), words = String(query).trim().split(/\s+/).map(normalize).filter(Boolean);
  const numbers = String(query).match(/\d+/g) || [];
  const targetNumbers = String(value).match(/\d+/g) || [];
  return words.length > 0 && words.every(word => target.includes(word)) && numbers.every(n => targetNumbers.includes(n));
}
export function rankProducts(products, query, brand = '') {
  const q = String(query).trim();
  return products.filter(p => !brand || p.brand === brand).map(p => {
    const model = q.length >= 2 && (p.models || []).find(m => matchesReference(m, q));
    const reference = q.length >= 2 && matchesReference(`${p.brand} ${p.reference}`, q);
    const title = q.length >= 2 && matchesReference(p.title, q);
    return {product:p, model, kind:model?'model':reference?'reference':'', score:model?100:reference?80:title?20:!q&&brand?1:0};
  }).filter(p => p.score > 0).sort((a,b) => b.score-a.score || a.product.title.localeCompare(b.product.title));
}

if (typeof customElements !== 'undefined' && !customElements.get('startoner-finder')) {
  const catalogs = new Map();
  customElements.define('startoner-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form'); this.input = this.querySelector('[name=q]');
      this.brand = this.querySelector('[data-brand]'); this.panel = this.querySelector('.st-finder__panel');
      this.status = this.querySelector('[role=status]'); this.list = this.querySelector('ul');
      this.request = 0;
      this.input.addEventListener('input', () => { clearTimeout(this.timer); this.timer=setTimeout(()=>this.update(),180); });
      this.input.addEventListener('focus',()=>this.load().catch(()=>{}));
      this.brand.addEventListener('change',()=>this.update());
      this.form.addEventListener('submit', async event => {event.preventDefault(); if(!await this.update()) this.form.submit();});
      this.input.addEventListener('keydown', event => {if(event.key==='Escape') this.panel.hidden=true;});
      document.addEventListener('click', event => {if(!this.contains(event.target)) this.panel.hidden=true;});
      if (location.pathname.endsWith('/search')) {
        this.input.value = new URLSearchParams(location.search).get('q') || '';
        if(this.input.value) this.update();
      }
    }
    async load() {
      if(this.products) return this.products;
      const key=this.dataset.catalogUrl;
      if(!catalogs.has(key)) catalogs.set(key,(async()=>{
        const products=[]; let url=new URL(key,location.origin); const visited=new Set();
        while(url && !visited.has(url.href)) {
          if(url.origin!==location.origin) throw new Error('Invalid catalog origin');
          visited.add(url.href);
          const response=await fetch(url,{credentials:'same-origin'});
          if(!response.ok) throw new Error('Catalog unavailable');
          const html=new DOMParser().parseFromString(await response.text(),'text/html');
          const data=JSON.parse(html.querySelector('[data-startoner-catalog]').textContent);
          products.push(...data.products.map(p=>({...p,models:Array.isArray(p.models)?p.models:[]})));
          url=data.next?new URL(data.next,location.origin):null;
          if(url) url.searchParams.set('section_id','st-finder-catalog');
        }
        return products;
      })().catch(error=>{catalogs.delete(key);throw error;}));
      this.products=await catalogs.get(key);
      if(this.brand.options.length===1) {
        [...new Set(this.products.map(p=>p.brand).filter(Boolean))].sort().forEach(b=>this.brand.add(new Option(b,b)));
        this.querySelector('.st-finder__filters').hidden=false;
      }
      return this.products;
    }
    async update() {
      const sequence=++this.request, query=this.input.value.trim();
      if(query.length<2&&!this.brand.value) {this.panel.hidden=true;document.body.classList.remove('st-exact-search');return false;}
      this.panel.hidden=false; this.status.textContent=this.dataset.loading;
      try {
        const products=await this.load();
        if(sequence!==this.request) return true;
        const results=rankProducts(products,query,this.brand.value);
        // 2026-10-11: the finder panel overlays the search grid instead of hiding it (hiding it caused CLS 0.6)
        this.list.replaceChildren();
        // 2026-10-10: on the search page, no finder match while Shopify already lists results is not "no matches"
        if(!results.length && location.pathname.endsWith('/search') && document.querySelector('#product-grid .grid__item')) {this.panel.hidden=true;return true;}
        this.status.textContent=results.length?`${this.dataset.count.charAt(0).toLocaleUpperCase()+this.dataset.count.slice(1)}: ${results.length}`:this.dataset.empty;
        for(const result of results) {
          const p=result.product, url=new URL(p.url,location.origin);
          if(url.origin!==location.origin) continue;
          const li=document.createElement('li'), a=document.createElement('a');a.href=url.href;
          if(p.image) {const img=document.createElement('img');img.src=p.image;img.alt='';img.width=56;img.height=56;img.loading='lazy';a.append(img);}
          const text=document.createElement('span'), title=document.createElement('strong');title.textContent=p.title;text.append(title);
          if(result.kind) {const detail=document.createElement('small');detail.textContent=`${this.dataset[result.kind]}: ${result.model || p.reference}`;text.append(detail);}
          a.append(text);
          const price=document.createElement('span');price.className='st-finder__price';price.textContent=`${p.varies?this.dataset.from+' ':''}${p.price}`;a.append(price);
          li.append(a);this.list.append(li);
        }
        return true;
      } catch {
        document.body.classList.remove('st-exact-search');
        if(sequence===this.request) {this.status.textContent=this.dataset.empty;this.list.replaceChildren();}
        return false;
      }
    }
  });
}
